// Funções puras de apoio ao ConfigFlow: conversão entre o formato do banco
// (model ItensFlow: tipo Int, identificador String, query Json, imagem/cor
// String?) e o formato usado pelos componentes da tela.

// Tipo: 0: ASN, 1: CDNs, 2: Tráfego (mesmo mapeamento do schema.prisma) —
// esta tela só cadastra/edita CDNs e Classes de tráfego
export const TIPO_CDN = 1;
export const TIPO_CLASSE = 2;

export const slugify = (value) =>
  (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

// Converte uma linha de itensFlow (banco) para o formato usado pela tela.
// Tanto CDN quanto Classe salvam a condição SQL completa em query (getTrafficCdn
// e getTrafficClasses usam o valor diretamente, sem montar nada a partir de
// uma lista de padrões).
export const mapRowToItem = (row) => ({
  id: row.id,
  tipo: row.tipo === TIPO_CDN ? "cdn" : "classe",
  identificador: row.identificador,
  cor: row.cor || null,
  icone: row.imagem || null,
  condicao: typeof row.query === "string" ? row.query : "",
});

// Converte os dados do formulário (tela) para o body esperado pelas rotas
// /interno/create/itensFlow e /interno/update/itensFlow
export const mapItemToPayload = (dados) => ({
  tipo: dados.tipo === "cdn" ? TIPO_CDN : TIPO_CLASSE,
  identificador: dados.identificador,
  query: dados.condicao,
  imagem: dados.icone || null,
  cor: dados.cor || null,
});
